import { render, staticRenderFns } from "./recordsDialog.vue?vue&type=template&id=e78e8e58&scoped=true&"
import script from "./recordsDialog.vue?vue&type=script&lang=js&"
export * from "./recordsDialog.vue?vue&type=script&lang=js&"
import style0 from "./recordsDialog.vue?vue&type=style&index=0&id=e78e8e58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e78e8e58",
  null
  
)

export default component.exports